import API_CONFIG from '../config/api.js';

const API_BASE_URL = API_CONFIG.BASE_URL;

class ClientService {
  constructor() {
    this.baseURL = `${API_BASE_URL}/api/clients`;
  }

  // Obtener token de localStorage
  getAuthToken() {
    return localStorage.getItem('token');
  }

  // Headers por defecto para las peticiones
  getHeaders() {
    const token = this.getAuthToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  // Manejar respuestas de la API
  async handleResponse(response) {
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Error en la petición');
    }
    
    return data;
  }

  // Obtener todos los clientes
  async getClients(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const url = `${this.baseURL}?${queryParams.toString()}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: this.getHeaders()
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error obteniendo clientes:', error);
      throw error;
    }
  }

  // Obtener un cliente por ID
  async getClient(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'GET',
        headers: this.getHeaders()
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error obteniendo cliente:', error);
      throw error;
    }
  }

  // Obtener cliente por ID
  async getClientById(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'GET',
        headers: this.getHeaders()
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error obteniendo cliente:', error);
      throw error;
    }
  }

  // Crear nuevo cliente
  async createClient(clientData) {
    try {
      const response = await fetch(this.baseURL, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(clientData)
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error creando cliente:', error);
      throw error;
    }
  }

  // Actualizar cliente
  async updateClient(id, clientData) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'PUT',
        headers: this.getHeaders(),
        body: JSON.stringify(clientData)
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error actualizando cliente:', error);
      throw error;
    }
  }

  // Eliminar cliente
  async deleteClient(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: 'DELETE',
        headers: this.getHeaders()
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error eliminando cliente:', error);
      throw error;
    }
  }

  // Restaurar cliente
  async restoreClient(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}/restore`, {
        method: 'PATCH',
        headers: this.getHeaders()
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error restaurando cliente:', error);
      throw error;
    }
  }

  // Obtener clientes eliminados (papelera)
  async getDeletedClients() {
    try {
      const response = await fetch(`${this.baseURL}/trash`, {
        method: 'GET',
        headers: this.getHeaders()
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error obteniendo clientes eliminados:', error);
      throw error;
    }
  }

  // Eliminar permanentemente
  async permanentDeleteClient(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}/permanent`, {
        method: 'DELETE',
        headers: this.getHeaders()
      });

      return await this.handleResponse(response);
    } catch (error) {
      console.error('Error eliminando permanentemente:', error);
      throw error;
    }
  }
}

const clientServiceInstance = new ClientService();
export default clientServiceInstance; 